module.exports = __webpack_public_path__ + "static/img/trip-notext.800530f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/services/trip-notext.png
// module id = 2K/Q
// module chunks = 1